export default "__VITE_ASSET__l6RiUwHk__"